import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popup from '../../../common/Popup';
import * as docketActions from '../../../../redux/actions/docketActions';
import { hasValidClientCode } from '../../../../redux/actions/clientCodeAction';
import ProgressBar from '../../../common/ProgressBar/ProgressBar';
import DocketDetailsPurchaseForm from './DocketDetailsPurchaseForm';
import loadingBarImage from '../../../../images/loadingBar.gif';

export class AllPartsPrintPreview extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
      this.downloadPdfCombined();
    }
  }

  buy = () => {
    if (this.props.dispatch(hasValidClientCode())) {
      const { documents, pacer_client } = this.props.popup.data;

      const params = {
        documents,
        pacer_client
      };

      this.props.dispatch(docketActions.buyAllParts(params)).then(() => this.downloadPdfCombined());
    } else {
      this.props.onClose();
    }
  };

  downloadPdfCombined = () => {
    const { documents, case_uuid, court_code, case_number } = this.props.popup.data;

    const params = {
      case_uuid,
      court_code,
      case_number,
      documents,
    };

    this.props.dispatch(docketActions.previewPdf(params)).then(this.props.reloadDetails);
  };

  // showing 10 instead of 0 as default, so it at least appears like it's loading something
  renderProgress = percentage => (
    <div>
      <ProgressBar percentage={percentage || 5} show />
    </div>
  );

  render() {
    const purchaseFormOrLoading =
      this.props.docketParts.status === 'loading' ? (
        <div className="loading-bar">
          <img src={loadingBarImage} />
        </div>
      ) : (
        <DocketDetailsPurchaseForm docketParts={this.props.docketParts} buy={this.buy} />
      );

    return (
      <Popup
        show={this.props.popup.show}
        clsName="docket-pdf-zip-popup"
        topBarTitle="Print Preview"
        onClose={this.props.onClose}
      >
        {purchaseFormOrLoading}
      </Popup>
    );
  }
}

AllPartsPrintPreview.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  reloadDetails: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const { popup, docketParts } = state.get('dockets').toJS();

  return {
    popup,
    docketParts,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(AllPartsPrintPreview);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/AllPartsPrintPreview.jsx